import { render, staticRenderFns } from "./ComponentShow.vue?vue&type=template&id=2f400492&"
import script from "./ComponentShow.vue?vue&type=script&lang=js&"
export * from "./ComponentShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports